export default function SvgCarbonNeutral() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 0C8.95397 0 0 8.95397 0 20C0 31.046 8.95397 40 20 40C31.046 40 40 31.046 40 20C40 8.95397 31.046 0 20 0ZM20 36.9796C10.623 36.9796 3.02038 29.3789 3.02038 20C3.02038 10.6211 10.6211 3.02038 20 3.02038C29.3789 3.02038 36.9796 10.6211 36.9796 20C36.9796 29.3789 29.3789 36.9796 20 36.9796Z"
        fill="black"
      ></path>
      <path
        d="M22.6328 20.4786C22.0959 19.2271 21.2411 18.0104 20.0926 16.8624C20.0007 16.7705 19.9072 16.6796 19.8121 16.5892C22.2343 13.1106 24.4997 11.2654 24.5625 11.2144C22.4713 12.5916 20.7335 14.3996 19.3563 16.1718C18.4408 15.3647 17.3999 14.6253 16.2509 13.9667C15.9411 13.7892 15.6272 13.6196 15.3098 13.4584C17.9559 9.40311 25.0553 6.99657 30.2107 8.04556C26.7196 11.0424 27.7394 18.6284 22.9444 21.3232C22.8573 21.0417 22.7535 20.7601 22.6328 20.4786Z"
        fill="black"
      ></path>
      <path
        d="M6.53229 11.8556C10.8662 17.0286 5.27857 29.4338 18.8958 30.0445C18.9207 30.0252 18.9455 30.0061 18.97 29.987C16.798 21.5939 12.3188 16.5194 12.2316 16.4209C15.5176 19.4604 17.6159 23.5403 18.8374 26.5886C18.8379 26.59 18.8384 26.5916 18.8391 26.5929C19.1608 27.4355 19.4824 28.335 19.7989 29.2917C19.8124 29.3328 19.8261 29.3742 19.8396 29.4155C20.0891 30.1747 20.3346 30.9695 20.5741 31.8L21.5059 31.6378C21.5059 31.6378 21.1541 30.4481 20.4567 28.6503C27.9294 20.791 15.489 11.5271 6.53229 11.8556Z"
        fill="black"
      ></path>
    </svg>
  );
}
